import React, { useState } from 'react';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { View } from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphMaterialTypes = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState({});

  return (
    <div className="ParagraphMaterialTypes">
      <Container small>
        <View
          id="materials"
          display="block_1"
          page={currentPage}
          filters={filters}
          setFilters={setFilters}
          setCurrentPage={setCurrentPage}
        />
      </Container>
    </div>

  );
};

export default ParagraphMaterialTypes;
